import request from '@/api/request'

/**
 * 获取合作申请列表
 */
export const getApplicationForList = (params) => {
    return request({
        url: '/radioweb/adm/cooperationApply/getListPage',
        params,
        method: 'get'
    })
}
/**
 * 添加合作申请
 */
export const addApplicationFor = (data) => {
    return request({
        url: '/radioweb/app/cooperationApply/addCooperationApply',
        data,
        method: 'post'
    })
}
/**
 * 获取合作项目介绍
 */
export const getProjectContent = () => {
    return request({
        url: '/radioweb/adm/cooperationApply/getProductIntroduction',
        method: 'get'
    })
}
/**
 * 设置合作项目介绍
 */
export const setProjectContent = (params) => {
    return request({
        url: '/radioweb/adm/cooperationApply/updateProductIntroduction',
        method: 'get',
        params
    })
}
/**
 * 合作申请添加备注
 */
export const addProjectCommit = (params) => {
    return request({
        url: '/radioweb/adm/cooperationApply/updateRemarks',
        method: 'get',
        params
    })
}
